export default {
  items: [
    {
      key: '1',
      name: 'Message 消息服务'
    }
  ],
  itemMap: {
    '1': [
      {
        key: '101',
        name: '接入文档',
        url: '/message'
      }
    ]
  }
}